import { createFileRoute } from "@tanstack/react-router";
import UserProfile from "@landingClient/pages/UserProfile";

export const Route = createFileRoute("/user/")({
  component: UserProfile,
});
